'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var tslib_es6 = require('../../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var ListItem = require('../ListItem/ListItem.js');
require('../NavbarMobile.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MobileSidebarMenu = function (props) {
    props.logoPath; var navigationMenu = props.navigationMenu; props.childMenu; props.grandChildMenu; var NextLink = props.NextLink;
    var _a = React.useState([]), collapsingItem = _a[0], setCollapsingItem = _a[1]; // list of collapsing menu on mobile sidebar
    var menuItem = function (item, title) {
        var toggleCollapse = function (item) {
            if (!collapsingItem.includes(item.title)) {
                var collapsingMenu = tslib_es6.__spreadArrays(collapsingItem);
                collapsingMenu.push(item.title);
                setCollapsingItem(collapsingMenu);
            }
            else {
                var collapsingMenu = collapsingItem.filter(function (menu) { return menu !== item.title; });
                setCollapsingItem(collapsingMenu);
            }
        };
        var toggleArrowIcon = function (item) {
            return (React__default['default'].createElement("span", null,
                React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--" + (collapsingItem.includes(item.title) ? "arrow-up-small" : "arrow-down-small") })));
        };
        var showChildItem = function (item) {
            return (React__default['default'].createElement("ul", { className: "child" }, item.childItems && item.childItems.map(function (child) { return child.title.toLowerCase() !== 'faq' &&
                React__default['default'].createElement("li", { key: child.title },
                    setLinkComponent(child),
                    child.childItems && child.childItems.length > 0 && collapsingItem.includes(child.title) &&
                        React__default['default'].createElement("ul", { className: "grandchild" }, child.childItems.map(function (item, index) {
                            return React__default['default'].createElement(ListItem.ListItem, { item: item, NextLink: NextLink });
                        }))); })));
        };
        var hasChildItem = item.childItems && item.childItems.length > 0;
        var setLinkComponent = function (item) {
            var hasChild = item.childItems && item.childItems.length > 0;
            if (hasChild) {
                return React__default['default'].createElement("a", { title: item.title, onClick: function () { return toggleCollapse(item); } },
                    React__default['default'].createElement("span", null, item.title),
                    toggleArrowIcon(item));
            }
            else if (NextLink) {
                return React__default['default'].createElement(NextLink, { href: item.link },
                    React__default['default'].createElement("a", { title: item.title, className: item.title === "Dapatkan Penawaran" ? "color__blue" : "" },
                        React__default['default'].createElement("span", null, item.title)));
            }
            else
                return React__default['default'].createElement("a", { href: item.link, title: item.title, className: item.title === "Dapatkan Penawaran" ? "color__blue" : "" },
                    React__default['default'].createElement("span", null, item.title));
        };
        return (React__default['default'].createElement("li", { key: title },
            setLinkComponent(item),
            hasChildItem && collapsingItem.includes(item.title) && showChildItem(item)));
    };
    return (React__default['default'].createElement("div", { className: "navigation__mobile--menu" },
        React__default['default'].createElement("img", { src: "https://lifepal.tech/static/images/lifepal-logo.png", alt: "Lifepal Logo", width: "91px", height: "31px" }),
        React__default['default'].createElement("ul", null, navigationMenu
            .filter(function (item) {
            return item.title === "Bantuan" ||
                item.stylingClass !== "pull-right";
        })
            .map(function (item) { return menuItem(item, item.title); }))));
};

module.exports = MobileSidebarMenu;
//# sourceMappingURL=MobileSidebarMenu.js.map
